import Classes from '../../join-form/JoinForm.module.scss';
import {Link} from 'react-router-dom';
const JoinTermsCondition = () => {
    return (
        <div className={Classes.JoinFormFooter}>
            By creating an account.You agree to
            Gifbuz's  <Link to={'/terms-conditions'} target={'_blank'}>Terms & Conditions</Link> and <Link to={'/privacy-policy'} target={'_blank'}>privacy
            policy</Link>.
        </div>
    );
};

export default JoinTermsCondition;